module.exports = __webpack_public_path__ + "static/media/alpacaConnection.12806657.gif";